import {getApiService} from '../services/HttpService';
import {CryptoHelper} from 'components/helpers/CryptoHelper';
import {MarketHelper} from 'components/helpers/MarketHelper';
import Api from 'constants/Api';

export const WALLET_CONSTANTS = {
    SET_WALLETS_DATA: 'WALLET_WALLETS_DATA',
    SET_BY_SYMBOL: 'WALLET_SET_BY_SYMBOL',
    SET_FIAT_BALANCE: 'WALLET_SET_FIAT_BALANCE',

    FAILURE: 'WALLET_FAILURE',
    RESET: 'WALLET_RESET',
};

export const handleSetWalletData = payload => ({
    type: WALLET_CONSTANTS.SET_WALLETS_DATA,
    payload
});

export const handleSpecificWalletBalance = payload => ({
    type: WALLET_CONSTANTS.SET_BY_SYMBOL,
    payload
})
export const handleSetFiatBalance = payload => ({
    type: WALLET_CONSTANTS.SET_FIAT_BALANCE,
    payload
})

export const handleReset = () => dispatch => {
    dispatch({
        type: WALLET_CONSTANTS.RESET
    })

    return Promise.resolve()
}